import { useEffect, useState } from 'react';

/**
 * Returns whether the browser tab is hidden.
 * @returns boolean
 */
export function useIsViewHidden() {
  const [viewIsHidden, setViewIsHidden] = useState(false);

  useEffect(() => {
    const processEvent: EventListener = () => {
      setViewIsHidden(document.hidden);
    };

    document.addEventListener('visibilitychange', processEvent);

    return () => {
      document.removeEventListener('visibilitychange', processEvent);
    };
  }, []);

  return viewIsHidden;
}
